import { useState, useEffect } from "react";

interface Result {
    appBarVisible: boolean;
    appBarOverThreshold: boolean;
}

function useIsAppBarVisible(): Result {
    const [appBarVisible, setAppBarVisible] = useState(true);
    const [appBarOverThreshold, setAppBarOverThreshold] = useState(false);
    const threshold = 100;

    useEffect(() => {
        // Sticky Header

        let prevScrollpos = window.pageYOffset;
        const scrollHandler = () => {
            const currentScrollPos = window.pageYOffset;

            if (currentScrollPos > threshold) {
                setAppBarOverThreshold(true);
                prevScrollpos > currentScrollPos ? setAppBarVisible(true) : setAppBarVisible(false);
                prevScrollpos = currentScrollPos;
            }
            else {
                setAppBarOverThreshold(false);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        return () => window.removeEventListener("scroll", scrollHandler);
    }, []);

    const result = { appBarVisible, appBarOverThreshold };

    return result;
}

export default useIsAppBarVisible;
